<template>
<div class="col-xs-12 col-sm-6">
  <h3>Winkelwagen</h3>
  <table v-if="products.length > 0" id="cart" class="table table-condensed">
    <thead>
      <tr>
        <th style="width:50%"></th>
        <th style="width:10%"></th>
        <th style="width:8%" ></th>
        <th style="width:22%"></th>
        <th style="width:10%"></th>
      </tr>
    </thead>
    <tbody v-for="product in products" track-by="$index">
      <tr>
        <td data-th="">
          <div class="row">
            <div class="col-sm-12">
              <p class="nomargin">{{product.Name}}</p>
            </div>
          </div>
        </td>
        <td colspan="3" class="text-right">
          <p><strong>{{product.Quantity}}x</strong></p>
        </td>
        <td colspan="3" class="text-right">
          <p><strong>{{product.Price | currencyDisplay}}</strong></p>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr class="visible-xs">
        <td colspan="5" class="text-center">
          <p><strong>subtotaal {{subtotal | currencyDisplay}}</strong></p>
          <p>
            <strong>Verzendkosten {{shippingCost | currencyDisplay}}</strong>
          </p>
          <h3><strong>Totaal {{totalPrice | currencyDisplay}}</strong></h3>
        </td>
      </tr>
      <tr class="hidden-xs">
        <td colspan="2"></td>
        <td colspan="3" class="text-right">
        <p><strong>subtotaal {{subtotal | currencyDisplay}}</strong></p>
        <p>
          <strong>Verzendkosten {{shippingCost | currencyDisplay}}</strong>
        </p>
        <h3><strong>Totaal {{totalPrice | currencyDisplay}}</strong></h3>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
<div class="col-xs-12 col-sm-6">
    <h3>
      Aflevergegevens
    </h3>
    <p>{{invoice.customer.sex}} {{invoice.customer.firstname}} {{invoice.customer.lastname}} </p>
    <p>{{invoice.customer.street}} {{invoice.customer.housenumber}}</p>
    <p>{{invoice.customer.zipcode}} {{invoice.customer.city}}</p>
</div>
</template>

<script>
import ac from 'accounting'
import shippingRatesData from '../../assets/shippingRates.json'

export default {
  props: {
    invoice: {
      type: Object,
      twoWay: true
    }
  },
  route: {
    canReuse: false
  },
  components: {
  },
  data () {
    return {
      shippingCost: shippingRatesData.shipping_rates[0].price
    }
  },
  created () {
  },
  methods: {
  },
  computed: {
    products: function () {
      return this.invoice.products
    },
    subtotal: function () {
      var total = 0
      for (var i = 0; i < this.products.length; ++i) {
        if (this.products[i].Quantity < 1) {
          this.products[i].Quantity = 1
        }
        total += parseFloat(ac.unformat(this.products[i].Price, ',')) * this.products[i].Quantity
      }
      return total
    },
    totalPrice: function () {
      return ((this.subtotal || 0) + (this.shippingCost || 0))
    }
  }
}
</script>



// WEBPACK FOOTER //
// confirm.vue?28113a9a